import { render, staticRenderFns } from "./NewPostButton.vue?vue&type=template&id=b52741da&scoped=true&"
import script from "./NewPostButton.vue?vue&type=script&lang=js&"
export * from "./NewPostButton.vue?vue&type=script&lang=js&"
import style0 from "./NewPostButton.vue?vue&type=style&index=0&id=b52741da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52741da",
  null
  
)

export default component.exports